/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Business,
    BusinessFromJSON,
    BusinessFromJSONTyped,
    BusinessToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetBusinessesChildrenResponse
 */
export interface GetBusinessesChildrenResponse {
    /**
     * 
     * @type {Array<Business>}
     * @memberof GetBusinessesChildrenResponse
     */
    children: Array<Business>;
}

export function GetBusinessesChildrenResponseFromJSON(json: any): GetBusinessesChildrenResponse {
    return GetBusinessesChildrenResponseFromJSONTyped(json, false);
}

export function GetBusinessesChildrenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessesChildrenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'children': ((json['children'] as Array<any>).map(BusinessFromJSON)),
    };
}

export function GetBusinessesChildrenResponseToJSON(value?: GetBusinessesChildrenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'children': ((value.children as Array<any>).map(BusinessToJSON)),
    };
}


